import { ChangeWebviewHeightRequestPayload, RefreshTypes } from "@swiggy-private/native-bridge";
import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";

import { FEATURE_NR_CALL_STATUS } from "@checkout-core/constants/FeatureNRCallStatus";
import { isQuickCheckoutFlow } from "@checkout-core/helpers/QuickCheckout";
import { buildNRLatencyMs } from "@checkout-core/helpers/FeatureNRHelpers";
import {
    QUICK_CHECKOUT_NB_STATE,
    recordQuickCheckoutNativeBridgeCall,
} from "@checkout-core/helpers/QuickCheckoutNREvents";
import { isAndroidPlatform, isiOSPlatform } from "@checkout-core/helpers/getSwiggyHeaders";
import { getBridgeSdk } from "@checkout-core/utils/BridgeSdk";
import { GlobalHeaderState } from "@checkout-core/utils/Headers";

/**
 * Inbound QC hops (MRO/Payments → QC) own webview height until the enter transition
 * finishes. The footer scale effect remounts immediately and must not shrink early.
 */
let inboundQcOwnsHeight = false;

export const beginInboundQcHeightTransition = (): void => {
    inboundQcOwnsHeight = true;
};

export const endInboundQcHeightTransition = (): void => {
    inboundQcOwnsHeight = false;
};

export const isInboundQcHeightPending = (): boolean => inboundQcOwnsHeight;

export const changeWebviewHeight = (payload: ChangeWebviewHeightRequestPayload, callback?: VoidFunction) => {
    const platform = (GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "").toLowerCase();
    const isAppPlatform = isAndroidPlatform(platform) || isiOSPlatform(platform);

    if (!isAppPlatform || __DEV__ || !isQuickCheckoutFlow()) {
        if (typeof callback === "function") {
            callback();
        }
        return;
    }

    const startMs = Date.now();
    getBridgeSdk()
        ?.changeWebviewHeight(payload)
        .then(() => {
            // Direction is already on recordQuickCheckoutNav for the hop — not repeated here.
            recordQuickCheckoutNativeBridgeCall({
                nbState: QUICK_CHECKOUT_NB_STATE.CHANGE_HEIGHT,
                status: FEATURE_NR_CALL_STATUS.SUCCESS,
                latencyMs: buildNRLatencyMs(startMs),
                height: payload?.height,
                heightType: payload?.type,
            });
            if (typeof callback === "function") {
                callback();
            }
        })
        .catch((error) => {
            // Bridge SDK / native layer already surface failures; avoid duplicate NR.
            console.error(error);
            if (typeof callback === "function") {
                callback();
            }
        });
};

export const refreshQuickCheckoutParentCollection = (): void => {
    // Fire-and-forget: callers do not await this callback; skip NR success/failure noise.
    getBridgeSdk()
        .refreshScreen({
            type: RefreshTypes.PARENT_SCREEN,
        })
        .then(() => {
            // no-op
        })
        .catch(() => {
            // no-op
        });
};
